module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_html.js
// module id = 60
// module chunks = 0